import {
  UPDATE_ACTIVE_DURATION,
  UPDATE_PRODUCT_SORTING,
  UPDATE_DASHBOARD_STATE,
  UPDATE_METRICS_DATA,
  UPDATE_GUIDE_MODAL,
  UPDATE_CUSTOM_DATE,
  UPDATE_SELECTED_CAROUSEL,
  UPDATE_SELECTED_DEVICE,
  UPDATE_VIDEO_DATA,
  UPDATE_PRODUCT_DATA,
} from "./Actions";

const _nullState = {
  selectedDuration: {
    value: "1y",
    label: "",
  },
  productSortingOptions: [
    "highest_sentiment",
    "lowest_sentiment",
    "new_products",
    "highest_video_reviews",
  ],
  productsSortBy: "highest_sentiment",
  videoReviewsCollected: {},
  videoReviewsCollectedLoading: false,
  userGuideModal: false,
  custom_start_date: "",
  custom_end_date: "",
  metricsData: null,
  fetchedVideoData: null,
  fetchedProductData: null,
  selectedCarousel: {
    id: "all",
    name: "",
  },
  selectedDevice: "Desktop",
};

const DashboardReducer = (state = _nullState, payload = {}) => {
  const {
    type,
    selectedDuration,
    productsSortBy,
    data,
    userGuideModal,
    customDate,
    metricsData,
    selectedCarousel,
    selectedDevice,
    fetchedVideoData,
    fetchedProductData,
  } = payload;
  switch (type) {
    case UPDATE_ACTIVE_DURATION:
      return {
        ...state,
        selectedDuration,
      };

    case UPDATE_PRODUCT_SORTING:
      return {
        ...state,
        productsSortBy,
      };
    case UPDATE_GUIDE_MODAL:
      return {
        ...state,
        userGuideModal,
      };
    case UPDATE_CUSTOM_DATE:
      return {
        ...state,
        ...customDate,
      };

    case UPDATE_DASHBOARD_STATE:
      return { ...state, ...data };

    case UPDATE_METRICS_DATA:
      return {
        ...state,
        metricsData,
      };
    case UPDATE_VIDEO_DATA:
      return {
        ...state,
        fetchedVideoData,
      };
    case UPDATE_PRODUCT_DATA:
      return {
        ...state,
        fetchedProductData,
      };
    case UPDATE_SELECTED_CAROUSEL:
      return {
        ...state,
        selectedCarousel: {
          id: selectedCarousel.id,
          name: selectedCarousel.name,
        },
      };
    case UPDATE_SELECTED_DEVICE:
      return {
        ...state,
        selectedDevice,
      };

    default:
      return state;
  }
};

export default DashboardReducer;
